const BASE_URL = `https://dakbuilder.kubernetes.netsyno.com`;

function asPdf(companies) {
  return DowloadAs({ companies, url: "pdfconvert" });
}

function asWord(companies) {
  return DowloadAs({ companies, url: "" });
}

async function DowloadAs({ companies, url }) {
  return fetch(`${BASE_URL}/${url}`, {
    method: "POST",
    headers: {
      authorization: "Token rx9ckf4djvwwmjfsmy9fxrr9udu7nhz3",
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      companies: companies.filter(c => c),
      existing_template_name: "stp_dak_template",
    }),
  })
    .then(res => res.blob())
    .then(blob => {
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
    });
}

export default {
  asPdf,
  asWord,
};
